import { useHttp } from "../http/useHttp";
import { useAxiosMfaMutation } from "../http/useAxiosMfaMutation";
import { paths } from "../generated-types";
import { useDefaultError } from "@synota-io/synota-shared-ui";

type PennyTestOperation = paths["/dashboard/synota/contracts/pennytest"]["post"];
export type UseContractPennyTestInput =
  PennyTestOperation["requestBody"]["content"]["application/json"];
export type IContractPennyTestResponse =
  PennyTestOperation["responses"][200]["content"]["application/json"];

export const useContractPennyTest = () => {
  const { client } = useHttp();

  const { isPending, status, data, error, mutate } = useAxiosMfaMutation<
    IContractPennyTestResponse,
    UseContractPennyTestInput
  >({
    mutationKey: ["create-penny-test-contract"],
    mutationFn: ({ ...input }) => client.post(`/synota/contracts/pennytest`, input),
  });

  useDefaultError(error, "Failed to create penny test");

  return { createPennyTest: mutate, isPending, status, data, error };
};

export type UseContractPennyTestReturn = ReturnType<typeof useContractPennyTest>;
